import React, { useEffect, useRef, useState } from 'react';
import { AnimatedComponent } from './BasicComponents';


function StudentCard(props) {    

    const animatedElementRef = useRef(null);
    let elt = React.createElement(props.element, props);

    return (
        <AnimatedComponent
            keyframes={props.anim_id === props.st_card_id ? props.anim_keyframes: []}
            options={props.anim_id === props.st_card_id ? props.anim_options: {}}
            onAnimationEnd={props.onAnimationEnd}
            animatedElementRef={animatedElementRef}
            defaultControl={props.anim_defaultControl}
        >
            <div className='card' ref={animatedElementRef}>
                <h1>{props.st_card_name}</h1>
                {elt}
            </div>
        </AnimatedComponent>
    )
}

function StudentCardsView(props) {
    let cardList = [];

    props.students.map(data => {
        let stCard = React.createElement(StudentCard, {...props, st_card_id: data.id, st_card_name: data.name, st_card: data, key: data.id});
        cardList.push(stCard);
    });

    return (
        <div className='card-view'>
            {cardList.map(data => (data))}
        </div>
    )
}

function GroupedCardView(props) {

    let usedIds = [];

    const groups = props.groups
        .map(group => {
            const students = props.students.filter(student =>
                props.assignments.some(a =>
                    a.group_id === group.id &&
                    a.student_id === student.id
                )
            );

            if(!students.length)
                return null;

            usedIds.push(...students.map(s => s.id));

            return {
                name: group.name,
                students
            };
        })
        .filter(Boolean);

    const remaining = props.students.filter(s => !usedIds.includes(s.id));

    if(remaining.length) {
        groups.push({
            name: props.remainingGroupName ?? "Remaining",
            students: remaining
        });
    }

    return (
        <div className='grouped-cards-view-containers'>
            {groups.map((val, index) => (
                <div className='grouped-cards-view' key={val.name + ":" + index}>
                    <span className='grouped-cards-name'>{val.name}</span>
                    <hr />
                    <StudentCardsView {...props} students={val.students} />
                </div>
            ))
            }
        </div>
    )
}

export { StudentCardsView, StudentCard, GroupedCardView };
